import React, { useState } from "react";
import copyIcon from "../../../../../Assets/copy.svg";
import convertToIST from "../../../../../services/istTime";

const DelayDropdown = ({ delayTime, setDelayTime, delayCount }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  
  const getOptionsForDelayCount = (count) => {
  if (count === 0)
    return [[1,2,3,4,5], [6,7,8,9,10], [11,12,13,14,15]];

  if (count === 1)
    return [[1,2,3,4,5]];

  return []; // block 3rd delay
};

  
  const allOptions = getOptionsForDelayCount(delayCount);
  
  // Show message for 3rd+ delays
  if (allOptions.length === 0) {
    return (
      <div style={{ marginTop: "10px", padding: "8px", fontSize: "14px", color: "#666" }}>
        Maximum delays reached
      </div>
    );
  }
  
  const currentOptions = allOptions[currentPage];
  
  const handleOptionClick = (value) => {
    if (value === "more") {
      setCurrentPage(prev => (prev + 1) % allOptions.length);
    } else {
      setDelayTime(value);
      setIsOpen(false);
    }
  };
  
  return (
    <div style={{ marginTop: "10px", position: "relative" }}>
      <div 
        onClick={() => setIsOpen(!isOpen)}
        style={{
          padding: "8px",
          border: "1px solid #ddd",
          borderRadius: "6px",
          fontSize: "14px",
          backgroundColor: "#fff",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <span>{delayTime ? `${delayTime} min` : "Select delay time"}</span>
        <span>{isOpen ? "â–²" : "â–¼"}</span>
      </div>
      
      {isOpen && (
        <div style={{
          position: "absolute",
          top: "100%",
          left: 0,
          right: 0,
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderTop: "none",
          borderRadius: "0 0 6px 6px",
          zIndex: 1000,
          maxHeight: "130px",
          overflowY: "auto"
        }}>
          {currentPage > 0 && (
            <div
              onClick={() => setCurrentPage(prev => prev - 1)}
              style={{
                padding: "8px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "bold",
                color: "#007bff",
                textAlign: "center",
                borderBottom: "1px solid #f0f0f0"
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = "#f8f9fa"}
              onMouseOut={(e) => e.target.style.backgroundColor = "#fff"}
            >
              --- Previous ---
            </div>
          )}
          {currentOptions.map(time => (
            <div
              key={time}
              onClick={() => handleOptionClick(time)}
              style={{
                padding: "8px",
                cursor: "pointer",
                fontSize: "14px",
                borderBottom: "1px solid #f0f0f0"
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = "#f8f9fa"}
              onMouseOut={(e) => e.target.style.backgroundColor = "#fff"}
            >
              {time} min
            </div>
          ))}
          {currentPage < allOptions.length - 1 && (
            <div
              onClick={() => handleOptionClick("more")}
              style={{
                padding: "8px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "bold",
                color: "#007bff",
                textAlign: "center"
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = "#f8f9fa"}
              onMouseOut={(e) => e.target.style.backgroundColor = "#fff"}
            >
              --- Show More ---
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const UpdatePopup = ({
  item,
  status,
  setStatus,
  handleStatusChange,
  handleUpdateStatus,
  handleClosePopup,
  copyToClipboard,
  copied,
  delayTime,
  setDelayTime,
  initialStatus,
  allowNoShowUpdate = false,
  statusOptions = ["Ready", "Delayed", "Completed"],
}) => {
 const getDelayCount = (item) => {
  return Array.isArray(item?.delayHistory)
    ? item.delayHistory.length
    : 0;
};


//console.log("Item Delay History:", item?.delayHistory);

  
  const delayCount = getDelayCount(item);
  // console.log("Delay Count:", delayCount);
  const isNoShowOrder = item.user?.orderStatus === "No-Show";
  const hasStatusChanged = status !== initialStatus || (status === "Delayed" && delayTime !== null);
  const isDelayedSelected = status === "Delayed";
  const canShowDelayDropdown = isDelayedSelected && delayCount < 2;
  const isUpdateDisabled = (isNoShowOrder && !allowNoShowUpdate) || !hasStatusChanged || (isDelayedSelected && canShowDelayDropdown && !delayTime);

  // Format created time once for readability and reuse
  const formattedCreatedTime = (() => {
    const { time, date } = convertToIST(item.createdTime);
    return date === "Today" ? `${time} | Today` : `${time} | ${date}`;
  })();

  return (
    <div className="update-popup">
      <div className="update-popup-content">
        <h4>UPDATE STATUS</h4>
        <p>
          Order ID #{item.id}
          <img
            src={copyIcon}
            alt="copy"
            onClick={() => copyToClipboard(item.id)}
            style={{ cursor: "pointer", marginLeft: "7px" }}
          />
          {copied && (
            <span
              className="copied-message"
              style={{ marginLeft: "5px", marginTop: "5px", color: "#69848a" }}
            >
              Copied
            </span>
          )}
        </p>
        <div
          style={{
            display: "flex",
            alignItems: "end",
            justifyContent: "space-between",
            marginTop: "-12px",
          }}
        >
          <div>
            <h2>{item.user.name}</h2>
            <p className="order-time">
              {formattedCreatedTime}
            </p>
          </div>
          <button className="takeaway-button">Takeaway</button>
        </div>
        <div>
          {item.user.items.length > 1 ? (
            // Render the dropdown if there are multiple items
            <select
              className="item-dropdown"
              value={`${item.user.items[0]?.quantity} X ${item.user.items[0]?.name}`}
            >
              <option value="placeholder" hidden>
                {item.user.items[0]?.quantity} X{" "}
                {item.user.items[0]?.name || "Default Item"}
              </option>
              {item.user.items.slice(1).map((itm, index) => (
                <option key={index} value={itm.name} disabled>
                  {itm.quantity}X {itm.name}
                </option>
              ))}
            </select>
          ) : (
            // Render plain text if there's only one item
            <div className="item-dropdown-static">
              {item.user.items[0]?.quantity} X{" "}
              {item.user.items[0]?.name || "Default Item"}
            </div>
          )}
        </div>
        <div
          style={{
            borderTop: "1px solid #BEBEBE",
            marginTop: "10px",
          }}
        >
          <h5>Choose current status</h5>
          {isNoShowOrder && !allowNoShowUpdate && (
            <div style={{ marginBottom: "10px", color: "red", fontSize: "12px" }}>
              Eatit team will proceed on this case.
            </div>
          )}
          {statusOptions.map((statusOption) => (
            <div key={statusOption}>
              <label style={{ color: (isNoShowOrder && !allowNoShowUpdate) || (statusOption === "Delayed" && item.user?.orderStatus === "Ready") ? "#ccc" : "inherit" }}>
                <input
                  type="radio"
                  name="status"
                  value={statusOption}
                  checked={status === statusOption || (status === "" && item.user?.orderStatus === statusOption)}
                  onChange={() => handleStatusChange(statusOption)}
                  disabled={(isNoShowOrder && !allowNoShowUpdate) || (statusOption === "Delayed" && item.user?.orderStatus === "Ready")}
                />
                {statusOption}
              </label>
              {statusOption === "Delayed" && isDelayedSelected && canShowDelayDropdown && (
                <DelayDropdown 
                  delayTime={delayTime} 
                  setDelayTime={setDelayTime} 
                  delayCount={delayCount}
                />
              )}
              {statusOption === "Delayed" && isDelayedSelected && !canShowDelayDropdown && (
                <div style={{ marginTop: "10px", color: "#999", fontSize: "14px" }}>
                  Maximum delays reached
                </div>
              )}
            </div>
          ))
        }
        </div>
        <div className="buttons">
          <button className="Close" onClick={handleClosePopup}>
            Close
          </button>
          <button
            className="Update"
            onClick={() => handleUpdateStatus(item.id)}
            disabled={isUpdateDisabled}
            style={{
              opacity: isUpdateDisabled ? 0.5 : 1,
              cursor: isUpdateDisabled ? 'not-allowed' : 'pointer'
            }}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdatePopup;

